export default {
  'aatest-example': false,
  'compliance-review-blocker': false,
  'disable-frontend-chainalysis': false,
  'disable-krw-default-currency': false,
  'enable-across-wallet-flow': false,
  'enable-add-token-to-wallet': false,
  'enable-bluvo-exchanges': false,
  'enable-btc-lightning-banner': false,
  'enable-checkout-success-screen-background': false,
  'enable-empty-withdrawal-selection': false,
  'enable-free-usdc-banner': false,
  'enable-fun-geo-primary': false,
  'enable-permit-toggle': false,
  'enable-perps-transfer-auto-close': false,
  'enable-polymarket-wallet-withdrawal': false,
  'enable-prefill-withdrawal-connected-address': false,
  'enable-quote-parallel-pipeline': false,
  'enable-rn-v2-deposit': false,
  'enable-rpc-xstock-assets': false,
  'enable-shadow-dom': false,
  'enable-swapped-exchanges': false,
  'enable-withdrawal-fees-notice': false,
  'exact-in': false,
  'faster-notifications': false,
  'hide-stablecoin-amount-switch': false,
  'new-token-transfer-config': false,
  'new-withdrawal-config': false,
  'remember-token-transfer-selection': false,
  'remember-withdrawal-chain': false,
  'saved-card-defaults-to-fiat-tab': false,
  'test-feature-gate': false,
  'wallet-flow-enable-exact-input-with-actions': false,
  'you-receive-remove-swap-impact': false,
} as const
